<template>
  <span class="line-height-lg">
    <span v-if="document_list_loaded">
      <span v-if="document_info?.type === 'file'" class="mr-3 mb-2">
        <template v-if="!print_mode">
          <a
            v-if="lang != 'ENG'"
            class="cursor"
            :style="main_color"
            @click="
              downloadFile(document_info?.title, $store.state.static_host + document_info?.path)
            "
            ><b-icon icon="file-earmark-text" class="mr-1" />
            <!-- :href="$store.state.static_host + path"
            target="_blank" -->
            {{ lang != 'ENG' ? document_info?.title : document_info?.title_e }}
          </a>
          <a
            v-else
            class="cursor"
            :style="main_color"
            @click="
              downloadFile(document_info?.title_e, $store.state.static_host + document_info?.path_e)
            "
          >
            <!-- :href="$store.state.static_host + path_e"
            target="_blank" -->
            <b-icon icon="file-earmark-text" class="mr-1" />
            {{ document_info?.title_e }}
          </a>
        </template>
        <template v-else>
          <a
            v-if="lang != 'ENG'"
            class="cursor"
            :style="main_color"
            :href="$store.state.static_host + document_info?.path"
            ><b-icon icon="file-earmark-text" class="mr-1" />
            {{ lang != 'ENG' ? document_info?.title : document_info?.title_e }}
          </a>
          <a
            v-else
            class="cursor"
            :style="main_color"
            :href="$store.state.static_host + document_info?.path"
          >
            <b-icon icon="file-earmark-text" class="mr-1" />
            {{ document_info?.title_e }}
          </a>
        </template>
      </span>

      <span v-else-if="document_info?.type === 'link'" class="mr-3 mb-2">
        <a
          v-if="lang != 'ENG'"
          class="cursor"
          :style="main_color"
          :href="document_info?.link"
          target="_blank"
        >
          <b-icon icon="link-45deg" class="mr-1" />
          {{ document_info?.title }}
        </a>

        <a v-else class="cursor" :style="main_color" :href="document_info?.link_e" target="_blank">
          <b-icon icon="link-45deg" class="mr-1" />
          {{ document_info?.title_e }}
        </a>
      </span>
      <span v-else-if="document_info?.type === 'storyboard'" class="mr-3 mb-2">
        <a
          v-if="lang != 'ENG'"
          class="cursor"
          :style="main_color"
          :href="document_info?.link"
          target="_blank"
        >
          <b-icon icon="box-arrow-up-right" class="mr-1" />
          {{ document_info?.title }}
        </a>

        <a v-else class="cursor" :style="main_color" :href="document_info?.link_e" target="_blank">
          <b-icon icon="box-arrow-up-right" class="mr-1" />
          {{ document_info?.title_e }}
        </a>
      </span>
    </span>

    <span v-else>
      <b-skeleton width="10%" />
    </span>
  </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { downloadFile } from '../../../util';
export default {
  name: 'Document',
  components: {},
  props: {
    document_id: { type: [String, Number], default: '' },
    document_obj: {
      type: Object,
      default() {
        return {};
      }
    },
    lazy_load: { type: Boolean, default: true },
    print_mode: { type: Boolean, default: false }
  },
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState(['backend_host']),
    ...mapState('report_list', ['report_code', 'lang', 'view_mode']),
    ...mapState('documents', ['document_list', 'document_list_loaded']),
    ...mapGetters('report_list', ['selected_report']),
    document_info() {
      const idx = this.document_list.findIndex(item => {
        return item.document_id == this.document_id;
      });
      if (idx > -1) {
        return this.document_list[idx];
      } else {
        return {};
      }
    },

    main_color() {
      return `color:` + this.selected_report.main_color;
    },
    main_color_sub() {
      return (
        `color:` +
        this.selected_report.main_color +
        `; border-top: 1px solid ` +
        this.selected_report.main_color +
        `!important` +
        `; border-bottom: 1px solid ` +
        this.selected_report.main_color
      );
    }
  },
  mounted() {},
  methods: {
    downloadFile
  }
};
</script>
